import { useLocation } from 'react-router-dom';

export const usePathname = () => {
  const location = useLocation();

  // Include search params for proper matching of routes with query parameters
  return location.pathname + location.search;
};
